<template>
  <!-- 模块组件
    @author: 王汝鹏
    @date: 2019-11-09
   -->
  <div class="preview-item-domain">
    <preview-item-template v-for="item in formNode.children"
                           :key="item.id"
                           :formNode="item"
                           :parent="formNode.children">
    </preview-item-template>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
}
</script>




// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemDomain.vue